import React from "react";
import { Navigate } from "react-router-dom";

type ProtectedRouteProps = {
  children: React.ReactElement;
  allowedRoles?: string[];
};

function ProtectedRoute({
  children,
  allowedRoles,
}: ProtectedRouteProps): React.ReactElement {
  const storedUser = sessionStorage.getItem("loggedInUser");

  if (!storedUser) {
    return <Navigate to="/login" replace />;
  }

  const user = JSON.parse(storedUser);

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    if (user.role === "admin") {
      return <Navigate to="/admin-dashboard" replace />;
    }

    if (user.role === "employee") {
      return <Navigate to="/employee-dashboard" replace />;
    }

    return <Navigate to="/login" replace />;
  }

  return children;
}

export default ProtectedRoute;